import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./Testimonials.scss";

const Testimonials = () => {
  return <CmsPage id={3} />;
};

export default Testimonials;
